// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"2cec1f06","82":"be5d520b","122":"bdc4e916","212":"180f83ba","213":"2d874c1d","239":"dc422d4d","454":"ab9a5ed2","526":"20beda36","610":"c501344a","667":"86b3f0eb","782":"82a0632d","883":"6218f6db","912":"b295bc73","966":"54bea048","968":"467269c6"}[chunkId] + ".chunk.js";
};